// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer---aQRS","links":"Footer-module--links--Uh7eg","socialLinks":"Footer-module--social-links--1Pio3"};